export default __webpack_public_path__ + "static/media/zupa.76cc4ae5.svg";